import { useLDClient } from 'launchdarkly-react-client-sdk';
import { UserContext } from './user';
import { useContext, useEffect } from 'react';
import { logError } from '../services';

// used to send the logged in user to LD so targeting works
export const LDWrapper = ({ children }) => {
  const ldClient = useLDClient();
  const { user, setUser } = useContext(UserContext);
  useEffect(() => {
    if (user) {
      ldClient.identify({
        key: user.userName.toLowerCase(),
        custom: {
          FullName: user.fullName
        }
      }, undefined, (err, flags) => {
        if (err) {
          logError(err, 'LaunchDarkly user flags failed to load');
          return;
        }
        setUser({ ...user, ldFlagsInitialized: true });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.userName]);
  return children;
};
